import { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import axiosApiInstance from '@/api/shared/axios-instance';
import { Rutas } from '@/constants/rutas';
import URL_FACTORY from '@/helpers/url-helper';

import CustomImageComponent from '../shared/custom/custom-image';
import CustomLink from '../shared/custom/custom-link';

import { getSocialNetworkIcon } from './colaboradores-helper';

const CardColaboradorComponent = () => {
    const [colaboradores, setColaboradores] = useState(null);

    useEffect(() => {
        const payload = {};
        axiosApiInstance.post(URL_FACTORY.GetColaboradores, payload).then((response) => {
            const filteredUsers = response.data?.users.filter(
                (user) =>
                    user.author === 'Dayán Ruiz' ||
                    user.author === 'Don Quijote de la Cancha' ||
                    user.author === 'Mundo del Fútbol' ||
                    user.author === 'Kromow' ||
                    user.author === 'Carlos Durán de la Cruz' ||
                    user.author === 'Gonzalo'
            );
            setColaboradores(filteredUsers);
        });
    }, []);

    const getColaboradorCard = (colaborador) => {
        return (
            <CustomLink
                className="colaboradores-container__card "
                href={`${Rutas.COLABORADORES}/${colaborador.author}`}
            >
                <Typography variant="h2" className="colaboradores-container__card__name">
                    {colaborador.name}
                </Typography>
                <CustomImageComponent
                    className="colaboradores-container__image"
                    src={colaborador.image}
                    alt={'colaborador'}
                    width={250}
                    height={250}
                    style={{ padding: '0 8px' }}
                />
                <Box className="colaboradores-container__card__social-networks">
                    {colaborador.socialNetworks?.map((socialNetwork, index) =>
                        getSocialNetworkIcon(socialNetwork, index)
                    )}
                </Box>
                <Typography variant="body1" className="colaboradores-container__footer">
                    Ver perfil del colaborador
                </Typography>
            </CustomLink>
        );
    };

    return (
        <Box className="colaboradores-container">
            <Typography variant="h2" className="colaboradores-container__header">
                Equipo
            </Typography>
            <Box className="colaboradores-container__row">
                {colaboradores
                    ?.filter((x) => x.image && x.owner)
                    ?.sort((a, b) => a.order - b.order)
                    ?.map((colaborador, i) => (
                        <Box className="colaboradores-container__row-card" key={i}>
                            {getColaboradorCard(colaborador, i)}
                        </Box>
                    ))}
            </Box>
            <Typography variant="h2" className="colaboradores-container__header">
                Colaboradores
            </Typography>
            <Box className="colaboradores-container__row">
                {colaboradores
                    ?.filter((x) => x.image && !x.owner)
                    ?.sort((a, b) => a.order - b.order)
                    ?.map((colaborador, i) => (
                        <Box className="colaboradores-container__row-card" key={i}>
                            {getColaboradorCard(colaborador, i)}
                        </Box>
                    ))}
            </Box>
        </Box>
    );
};

export default CardColaboradorComponent;
